import { useTranslation } from "react-i18next";
import { Button, Dialog } from "react-native-paper";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import DialogWrapper from "../DialogWrapper";
import ScrollContainer from "../ScrollContainer";
import { AutoRedeemContentView } from "./AutoRedeemContentView";
import type { RedeemStatus, RedeemablePurchase } from "./types";

type Props = {
	visible: boolean;
	onDismiss: () => void;
	purchases: RedeemablePurchase[];
	email: string;
	redeemStatus?: RedeemStatus;
	onAction: () => void;
	selectedProducts: string[];
	onSelectProduct: (id: string) => void;
	redeemedProductsExamName: string;
};

export const AutoRedeemDialog = ({
	visible,
	onDismiss,
	purchases,
	email,
	redeemStatus,
	onAction,
	selectedProducts,
	onSelectProduct,
	redeemedProductsExamName,
}: Props) => {
	const { t } = useTranslation();
	const hasRedeemed = redeemStatus === "redeemed";
	const isRedeeming = redeemStatus === "redeeming";

	const title = hasRedeemed
		? t("redeemCode.titleGranted")
		: t("redeemCode.titleRedeem");
	const icon = hasRedeemed ? "check-circle" : "basket-fill";

	const cta = isRedeeming
		? t("autoRedeem.redeeming")
		: hasRedeemed
			? t("autoRedeem.continue")
			: t("autoRedeem.redeem");

	const { isMobile } = useDevice();

	return (
		<DialogWrapper
			visible={visible}
			handleClose={onDismiss}
			width={isMobile ? "100%" : 420}
		>
			<Dialog.Icon icon={icon} />
			<Dialog.Title style={{ textAlign: "center" }}>{title}</Dialog.Title>
			<Dialog.ScrollArea
				theme={{
					colors: {
						surfaceVariant: "transparent",
					},
				}}
			>
				<ScrollContainer showsVerticalScrollIndicator={false}>
					<AutoRedeemContentView
						purchases={purchases}
						email={email}
						redeemStatus={redeemStatus}
						selectedProducts={selectedProducts}
						onSelectProduct={onSelectProduct}
						redeemedProductsExamName={redeemedProductsExamName}
					/>
				</ScrollContainer>
			</Dialog.ScrollArea>
			<Box paddingHorizontal={40} paddingVertical={16}>
				<Button
					onPress={onAction}
					loading={isRedeeming}
					disabled={isRedeeming || selectedProducts.length === 0}
					mode="contained"
				>
					{cta}
				</Button>
			</Box>
		</DialogWrapper>
	);
};
